"use client"




import {Column} from "@/core/general/column.component";
import {SearchField} from "@/core/general/searchFiled.component";
import {toPersianNumber} from "@/core/utils/number.utils";
import {checkWorldCountryListIncludeSearchString} from "@/core/tools/world_wiki/worldCountry.utils";
import React, {useEffect, useState} from "react";
import {WorldModel} from "@/core/tools/world_wiki/worldCountry.model";
import {useTranslations} from "use-intl";
import {Row} from "@/core/general/row.component";
import {Drawer} from "@mui/material";
import LayoutDrawer from "@/core/general/layoutDrawer.component";
import CloseIcon from "@mui/icons-material/CloseRounded";
import WorldData from './data/world.json';
import {ItemTagValue} from "@/core/general/itemTagValue.component";
import Twemoji from 'react-twemoji';

export default function WorldWikiComponent(){
    const [worldList, setWorldList] = useState<WorldModel[]>([]);
    const [searchWorldList, setSearchWorldList] = useState<WorldModel[]>([]);
    const [choosesWorld, setChoosesWorld] = useState<WorldModel>();
    const [searchText, setSearchText] = useState('');
    const [resultOpen, setResultOpen] = React.useState(false);
    const t = useTranslations();

    useEffect(() => {
        // @ts-ignore
        setWorldList(WorldData);
        // @ts-ignore
        setSearchWorldList(WorldData);
    }, []);

    const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
        setSearchText(toPersianNumber(event.currentTarget.value));
        setSearchWorldList(checkWorldCountryListIncludeSearchString(worldList, toPersianNumber(event.currentTarget.value)));
    };

    const handleWorldClick = (world: WorldModel) => {
        setChoosesWorld(world);
        setResultOpen(true);
    };

    return (
        <Column className={"w-full"}>
                <Column className="mt-1 p-2 totalCenter w-full">
                    <SearchField searchTag={t('search')} type={'text'} searchText={searchText} onChangeText={handleChange} />
                    <Column className="totalCenter px-2 mt-2 w-full">
                        {searchWorldList
                            ? searchWorldList.map((world, index) => (
                                <Column className="totalCenter w-full" key={index}>
                                    <Row
                                        onClick={() => handleWorldClick(world)}
                                        key={index}
                                        className="btn p-2 totalCenter w-full"
                                    >
                                        <Twemoji options={{ className: 'twemoji' }}>
                                            <div className={"!w-8 !h-8 overflow-hidden"}>
                                                {getFlagEmoji(world.Code)}
                                            </div>
                                        </Twemoji>
                                        <div className="grow text-right mx-2 mText">{world.Name}</div>
                                        <div className="w-auto text-left ms-2 me-3 mText">{toPersianNumber(world.Tel.toString())}</div>
                                    </Row>
                                    <div className="separatorLine w-90" />
                                </Column>
                            ))
                            : null}
                    </Column>
                </Column>
                <Drawer
                    anchor={'bottom'}
                    open={resultOpen}
                    PaperProps={{ square: false, elevation: 0, style: { backgroundColor: 'transparent' } }}
                    onClose={() => setResultOpen(!resultOpen)}
                >
                    <LayoutDrawer className={"w-full"}>
                        <CloseIcon fontSize={'large'} onClick={() => setResultOpen(false)} className="closeIcon" />
                        <Column className="hideScrollBar mt-6 w-full">
                            {choosesWorld && choosesWorld.EnglishName ? (
                                <Column className="align-end p-3 rounded-md items-center mb-2 cardBackground w-full">
                                    <Column className={"w-full"}>
                                        <Row
                                            dir="rtl"
                                            className="btn m-1 p-2 totalCenter"
                                            style={{
                                                height: '3rem'
                                            }}
                                        >
                                            <Twemoji options={{ className: 'twemoji' }}>
                                                <div className={"!w-8 !h-8 overflow-hidden"}>
                                                    {getFlagEmoji(choosesWorld.Code)}
                                                </div>
                                            </Twemoji>
                                            <div className="grow text-right mx-2 mText">{choosesWorld.Name}</div>
                                            <div className="w-auto text-left ms-2 me-1">{toPersianNumber(choosesWorld.Tel.toString())}</div>
                                        </Row>
                                        <div className="w-full mt-2 separatorLine" />
                                    </Column>
                                    <ItemTagValue tag={t('other.latinName')} value={choosesWorld.EnglishName.replaceAll('_', ' ')} />
                                    <ItemTagValue tag={t('other.capital')} value={choosesWorld.Capital} />
                                    <ItemTagValue tag={t('other.religion')} value={choosesWorld.Religion} />
                                    <ItemTagValue tag={t('other.population')} value={choosesWorld.Population} />
                                    <ItemTagValue tag={t('other.officialLanguage')} value={choosesWorld.Language} />
                                    <ItemTagValue tag={t('other.area')} value={choosesWorld.Area} />
                                    <ItemTagValue tag={t('other.governmentType')} value={choosesWorld.Government} />
                                    <ItemTagValue tag={t('other.currency')} value={choosesWorld.Currencies} />
                                    <ItemTagValue tag={t('other.telephonePrefix')} value={choosesWorld.Tel.toString()} />
                                    {choosesWorld.Barcode ? (
                                        <ItemTagValue tag={t('other.barcodePrefix')} value={choosesWorld.Barcode.replaceAll(';', ' , ')} />
                                    ) : null}
                                    {choosesWorld.Meaning ? (
                                        <div className="w-full">
                                            <div className="flex flex-row p-2">
                                                <div className="grow text-right" dir="rtl">
                                                    {t('other.nameMeaning')} {choosesWorld.Meaning}
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    <a
                                        href={`https://fa.m.wikipedia.org/wiki/${choosesWorld.Name}`}
                                        className="mt-3 w-3/4 text-bold text-white text-center calculateButton"
                                    >
                                        {t('other.showOnWikipedia')}
                                    </a>
                                </Column>
                            ) : null}
                        </Column>
                    </LayoutDrawer>
                </Drawer>
            </Column>
    );
}

export function getFlagEmoji(countryCode: string): string {
    // Ensure the code is uppercase for consistency
    const upperCaseCode = countryCode.toUpperCase();

    // Each letter is converted to a Unicode code point for regional indicators,
    // by adding 127397 (0x1F1A5) to its char code
    const codePoints = [...upperCaseCode].map((char) => char.charCodeAt(0) + 127397);

    // Construct and return the emoji flag
    return String.fromCodePoint(...codePoints);
}